import { FC, memo } from "react";
import { Box } from "@mui/material";
import { ResourceType } from "@/services/cloudchipr.api";
import { CreateIntegrationResourcesTable } from "@/components/common/integration-dialogs/components/common/CreateIntegrationResourcesTable";

export interface CreateEmailResourcesTableProps {
  resourceType: ResourceType;
}

export const CreateEmailResourcesTable: FC<CreateEmailResourcesTableProps> =
  memo(({ resourceType }) => {
    return (
      <Box
        bgcolor="white"
        p={1}
        border={1}
        borderColor="grey.300"
        borderTop={0}
      >
        <CreateIntegrationResourcesTable resourceType={resourceType} />
      </Box>
    );
  });
